import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-like-1",
  "use": "foquz-icon-rating-like-1-usage",
  "viewBox": "0 0 10 11",
  "content": "<symbol viewBox=\"0 0 10 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-like-1\"><path d=\"M6.297 7s.353 1.825.353 2.363-.044.936-.353 1.246c-.31.31-.477.5-.967.323-.723-.261.389-1.584-3.67-4.59V.334L8.185 0a1.096 1.096 0 011.097.936l.706 4.797a1.105 1.105 0 01-.636 1.17 1.095 1.095 0 01-.462.096H6.297zM0 6.342h1.66V.334H0v6.008z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol